import { Injectable } from '@angular/core'
import { CanActivate, Router, UrlTree } from '@angular/router'
import { distinctUntilChanged, filter, map, Observable, shareReplay } from 'rxjs'
import { Scope } from '../models'
import { isQueryFailed, isQueryEnded, ScopeService } from '../services/scope.service'

@Injectable({ providedIn: 'root' })
export class ScopesGuard implements CanActivate {
  constructor (
    private scopeService: ScopeService,
    private router: Router
  ){}

  canActivate (route): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.scopeService.scopesListQuery$.pipe(
      filter(isQueryEnded),
      map(serverQuery=>{
        if(isQueryFailed(serverQuery)) return this.router.parseUrl('')
        const targetedScope = serverQuery.data.find(scope => Scope.idOf(scope) === route.params.scopeId)
        if(targetedScope && Scope.isViewAllowed(targetedScope)) return true
        return this.router.parseUrl('')
      }),
      distinctUntilChanged(),
      shareReplay(1)
    )
  }

}
